import {
  PersonDataResponse,
  personMachine,
} from '~domains/profile/entities/person';

import { recoverPersonValues } from './recover';

export const getPersonMachineSnapshot = (person: PersonDataResponse) => {
  const values = recoverPersonValues(person);

  return personMachine.resolveState({
    value: 'basicInfo',
    context: {
      ...values,
    },
  });
};
